import { render, staticRenderFns } from "./pieRight.vue?vue&type=template&id=ef77c3a2&scoped=true&"
import script from "./pieRight.vue?vue&type=script&lang=js&"
export * from "./pieRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef77c3a2",
  null
  
)

export default component.exports